import { Mqtt_Topics_mediaChanges } from "../ThreeDocs.Models/Api/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg } from "./MediaTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_mediaChanges(uid)), (Item) => (new Msg(17, [Item]))];
}

